import type { Configuration, EventSourceOptions } from './Types';
import { EventSourcePolyfill } from 'event-source-polyfill';

import { Environment } from '@cobliteam/react-environments';

import { getAuthHeaders } from '../account/session/AuthToken';
import { SessionManager } from '../account/session/SessionManager';
import { getOpenTelemetryBaggageHttpHeaders } from '../openTelemetryBaggage';

const env = Environment.getInstance().getEnvironment();

export class EventSourceRequester {
  private baseUrl: string;

  private useEventSourceLibrary: boolean;

  private sessionManager: SessionManager;

  constructor(
    configuration: Configuration & { useEventSourceLibrary: boolean },
    sessionManager: SessionManager = new SessionManager({
      host: env.herbieApiHost,
    })
  ) {
    this.baseUrl = configuration.host;
    this.useEventSourceLibrary = configuration.useEventSourceLibrary;
    this.sessionManager = sessionManager;
  }

  public subscribe = (
    options: EventSourceOptions
  ): Promise<EventSource | EventSourcePolyfill> =>
    this.sessionManager.maybeRenewAccessToken().then(() => {
      if (this.useEventSourceLibrary) {
        return new EventSourcePolyfill(this.baseUrl + options.url, {
          headers: {
            ...getAuthHeaders(),
            ...getOpenTelemetryBaggageHttpHeaders(),
          },
        });
      }

      return new EventSource(this.baseUrl + options.url, {
        withCredentials: true,
      });
    });

  public static unsubscribe = (
    eventSource: EventSource | EventSourcePolyfill
  ) => eventSource.close();
}

export default EventSourceRequester;
